import { AgentLeadStoreFactory } from 'common/data/agent-lead/store.factory';

import { AgentLeadStoreServiceInterface } from './service.interface';

const agentLeadStore = AgentLeadStoreFactory();

export function AgentLeadStoreService(): AgentLeadStoreServiceInterface {
  return agentLeadStore;
}
